import React from 'react';
import { connect } from 'react-redux';
import { ObjectiveFlag } from '_components';
import styles from './Common.module.css'
import { ObservationGeneralRow } from './ObservationGeneralRow';

class ObservationGeneral extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='General Observations'/>
                    <label className={styles.label_wide}>General Observations</label>
                </div>

                <ObservationGeneralRow label='Pitting Edema' checkboxColumnName='OOGENPITTING' textareaColumnName='OOGENPITTINGTXT' />
                <ObservationGeneralRow label='Radiation Burns' checkboxColumnName='OOGENRADIA' textareaColumnName='OOGENRADIATXT' />
                <ObservationGeneralRow label='Scars' checkboxColumnName='OOGENSCARS' textareaColumnName='OOGENSCARSTXT' />
                <ObservationGeneralRow label='Lymphatic Fistulas' checkboxColumnName='OOGENFISTULAS' textareaColumnName='OOGENFISTULASTXT' />
                <ObservationGeneralRow label='Ulcers' checkboxColumnName='OOGENULCERS' textareaColumnName='OOGENULCERSTXT' />
                <ObservationGeneralRow label='Collateral Veins' checkboxColumnName='OOGENCOLLATVEIN' textareaColumnName='OOGENCOLLATVEINTXT' />
                <ObservationGeneralRow label='Fibrosis' checkboxColumnName='OOGENFIBROSIS' textareaColumnName='OOGENFIBROSISTXT' />
                <ObservationGeneralRow label='Stemmer Sign' checkboxColumnName='OOGENSTEMMER' textareaColumnName='OOGENSTEMMERTXT' />
                <ObservationGeneralRow label='Lymphatic Cysts' checkboxColumnName='OOGENCYSTS' textareaColumnName='OOGENCYSTSTXT' />
                <ObservationGeneralRow label='Skin Folds' checkboxColumnName='OOGENSKINFOLD' textareaColumnName='OOGENSKINFOLDTXT' />
                <ObservationGeneralRow label='Papillomas' checkboxColumnName='OOGENPAPILLOMAS' textareaColumnName='OOGENPAPILLOMASTXT' />
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOGENPITTING ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGENRADIA ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGENSCARS ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGENFISTULAS ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGENULCERS ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGENCOLLATVEIN ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGENFIBROSIS ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGENSTEMMER ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGENCYSTS ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGENSKINFOLD ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGENPAPILLOMAS
            ? true : false
    };
}

const connectedObservationGeneral = connect(mapStateToProps)(ObservationGeneral);
export { connectedObservationGeneral as ObservationGeneral };


